'use client';

import { useState, useRef } from 'react';
import { useScroll, useMotionValueEvent } from 'framer-motion';
import smoothscroll from 'smoothscroll-polyfill';
import { TargetToTopButton } from '@/components/widgets/to-top-button';
import { useAccountInfo } from '@/hooks/query/account';
import { usePathname, useSelectedLayoutSegments } from 'next/navigation';
import { BetsPanel } from './components/bets-panel';
import { StreamingPanel } from './components/streaming-item';
import { useAuthToken } from '@/store/auth';
import { useStreamingStore } from '@/store/streaming';
import { useCurrentProperties } from '@/hooks/query';
import { isNumberGames, isVirtualSports } from '@/services/settings.service';
import clsx from 'clsx';
import { sportsbookAsideStyle } from './sportsbook-aside.style';
import { PromotionAsie } from '../promotion-aside';

export const SportsbookAside = () => {
	const { sport } = useCurrentProperties();
	const pathName = usePathname();
	const authToken = useAuthToken();
	const { user } = useAccountInfo();
	const asideScrollableRef = useRef<HTMLDivElement>(null);
	const { scrollY: asideScrollY } = useScroll({ container: asideScrollableRef });
	const [isVisible, setIsVisible] = useState(false);
	const selectedLayoutSegments = useSelectedLayoutSegments();
	const isNoneSidePage = selectedLayoutSegments.includes('jackpot') || selectedLayoutSegments.includes('widget') || selectedLayoutSegments.includes('lottery') || selectedLayoutSegments.includes('golden-duel') ;
	const isPromotionPage = selectedLayoutSegments.includes('promotion');
	const [isExpandChatroom, streamingPluginUrl, chatroomUrl] = useStreamingStore(
		state => [state.isExpnadChatroom, state.streamingSrc, state.streamingPluginUrl, state.chatroomUrl]
	);
	const hasIframeUrl = chatroomUrl !== '' || streamingPluginUrl !== '';
	const isThirdParty = isVirtualSports(sport) || isNumberGames(sport);

	useMotionValueEvent(asideScrollY, 'change', (latest) => {
		setIsVisible(latest > 30)
	});

	const scrollToTop = () => {
		smoothscroll.polyfill();
		asideScrollableRef.current?.scroll({
			top: 0,
			behavior: 'smooth'
		});
	};

	if (isNoneSidePage || isThirdParty) {
		return null;
	}

	if (isPromotionPage) {
		return  <PromotionAsie />
	}

	return (
		<aside className={clsx('main-wrap__aside wrap-scrollbar', sportsbookAsideStyle.aside)} 
			ref={asideScrollableRef} 
			{...(hasIframeUrl ? { 'data-chatroom-open': isExpandChatroom ? true : false } : {})}
		>
			<div id="aside-topbar-portal" className={sportsbookAsideStyle.asideTopbarPortal}></div>
			<div className={sportsbookAsideStyle.stickyLayout}>
				{pathName.indexOf('outright') === -1 ? <StreamingPanel /> : null}
				{(authToken && user?.ActStatus === 2) ? <BetsPanel /> : null}
			</div>
			<TargetToTopButton
				className="desktop"
				onScrollToTop={scrollToTop}
				isVisible={isVisible}
			/>
		</aside>
	)
};